import routeNames from '@/router/routes'
import router from '@/router'
import { AuthRequests } from '@/services/auth.requests'
const authService = new AuthRequests()
const state = {
  authToken: localStorage.getItem('token'),
  credentials: null,
}

const getters = {
  previousToken: () => localStorage.getItem('previousToken'),
  authStatus: state => state.authToken != null,
  authToken: state => state.authToken,
}

const actions = {
  signOut: ({ commit }) => {
    commit('removeTokens')
    if (router.currentRoute.name && router.currentRoute.name !== routeNames.login.name) {
      router.push({ name: routeNames.login.name })
    }
  },
  signIn: ({ commit, dispatch }, { email, password }) => {
    dispatch('signOut')
    return new Promise((resolve, reject) => {
      authService.login(email, password).then(({ token }) => {
        commit('replaceAuthToken', token)
        dispatch('service/getConfiguration', null, { root: true })
        dispatch('me/getBookings', null, { root: true })
        router.push({ name: routeNames.main.name })
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  sendAccessMail: ({ state }, { email }) => {
    return new Promise((resolve, reject) => {
      authService.sendAccessMail(email).then(() => {
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  revokeAuth ({ state }, { operator }) {
    return new Promise((resolve, reject) => {
      authService.revoke(operator.id).then(() => {
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  whoAmI ({ commit, state, dispatch }, { getSaved }) {
    return new Promise((resolve, reject) => {
      if (getSaved && state.credentials) {
        resolve(state.credentials)
      } else {
        authService.whoAmI().then(async (credentials) => {
          commit('setCredentials', credentials)
          resolve(credentials)
        }).catch((error) => {
          dispatch('signOut')
          reject(error)
        })
      }
    })
  },
}

const mutations = {
  replaceAuthToken: (state, token) => {
    state.authToken = token
    localStorage.setItem('token', token)
  },
  removeTokens: (state) => {
    state.authToken = null
    state.credentials = null
    localStorage.removeItem('token')
  },
  setCredentials: (state, credentials) => {
    state.credentials = credentials
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
